import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchAuditLogs(params = {}) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, String(value));
    }
  });

  const suffix = query.toString() ? `?${query.toString()}` : '';
  const res = await apiFetch(`${API_BASE}/admin/audit${suffix}`);
  return res.json();
}

export async function fetchAuditLogDetail(auditId) {
  const res = await apiFetch(`${API_BASE}/admin/audit/${auditId}`);
  return res.json();
}

export async function exportAuditLogsCsv(params = {}) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, String(value));
    }
  });

  const suffix = query.toString() ? `?${query.toString()}` : '';
  const res = await apiFetch(`${API_BASE}/admin/audit/export/csv${suffix}`);

  if (!res.ok) {
    throw new Error('Failed to export audit logs');
  }

  return res.blob();
}
